import React from 'react';
import { Link } from "react-router-dom";
import '../style/Home.scss';

const Home = () => {
  return (
    <main className="page">
      <section className="main-sec">
        <p>
          This Knowledge Hub helps you find books easily. You can search by the name of a book and get the information you need. In the future, podcasts and articles will also be added to make learning more simple and interesting. This platform is for anyone who wants to explore knowledge in an easy way.
        </p>
      </section>
      
      <nav className="links" aria-label="Main navigation">
        <Link to="/about" >Why Knowledge Hub</Link>
        <Link to="/signup">Sign Up to Explore</Link>
        <Link to="/connect-with-us">Connect With Us</Link> 
      </nav>
    </main>
  );
};

export default Home;
